/**
 * Up-to-two-letter initials for an avatar fallback, e.g. `"ნინო ბერიძე" → "ნბ"`,
 * `"Jane Doe" → "JD"`. Trims, splits on whitespace, takes the first glyph of the
 * first two words, and upper-cases the result.
 */
export const getNameInitials = (name: string): string =>
    name
        .trim()
        .split(/\s+/)
        .map((part) => part[0] ?? '')
        .slice(0, 2)
        .join('')
        .toUpperCase();
